import { ComponentProps } from 'react';

import { cx } from '@/ui/cva';

type SectionIntroProps = ComponentProps<'div'>;

export function SectionIntro({ className, ...props }: SectionIntroProps) {
    return (
        <div
            {...props}
            className={cx('mt-sm max-w-[840px] md:mt-md', className)}
        />
    );
}
